import Close from "assets/images/close-black.svg";
import { Button } from "components/ui/Button";

import s from "./Modal.module.css";

export const DeleteModal = ({
  title,
  children,
  onClose,
  onSave,
  width,
  height,
  position,
  hideCancel,
  maxHeight,
  padding,
  overflowY,
  saveBtnTitle,
}) => {
  return (
    <div
      style={{
        width: width,
        height: height,
        padding: padding,
      }}
      className={s.modalContent}
    >
      <div className={s.modalHeader}>
        <h2 style={{ fontSize: "24px" }}>{title}</h2>
        <button className={s.closeButton} onClick={onClose}>
          <div className={s.modaHeaderBackground}></div>
          <img src={Close} alt="close icon" />
        </button>
      </div>
      <div
        className={s.modalBody}
        style={{
          height: height,
          maxHeight: maxHeight || undefined,
          overflowY: overflowY,
        }}
      >
        {children}
      </div>
      <div style={{ justifyContent: position }} className={s.modalFooter}>
        {onClose && !hideCancel && (
          <Button
            variant="outline"
            onClick={onClose}
            className={s.footerButton}
          >
            Cancel
          </Button>
        )}
        {onSave && (
          <Button variant="primary" onClick={onSave}>
            {saveBtnTitle || "Save"}
          </Button>
        )}
      </div>
    </div>
  );
};
